import React from "react";
import ProductCrudTableRow from "./ProductCrudTableRow";
import C from "helpers/HelpConstants";
import { HelpAbility } from "helpers/HelpAbility";
import ReactPaginate from "react-paginate";
import { ITEMS_BY_PAGE_OPTIONS } from "constants/pagination";


const ProductCrudTable = ({ products, editData, deleteData, listProducts, countPages, setModalShow, setProduct, itemsPerPage, setItemsPerPage, resetSearch, hasSearched }) => {
    let myAbilities = HelpAbility();
    const handlePageClick = async (data) => {
        console.log(data.selected);
        listProducts(data.selected + 1);
    };

    const resetList = async () => {
        resetSearch();
        listProducts(1);
    };

    const onItemsPerPageChange = (e) => {
        const newItemsPerPage = e.target.value;
        setItemsPerPage(newItemsPerPage);
        listProducts(1, newItemsPerPage)
    }

    const showActions = myAbilities.hasAny([
        C.A.PRODUCT.UPDATE,
        C.A.PRODUCT.DELETE,
        C.A.CENTER.LINK
    ]);

    return (
        <div className="mt-4">
            <div className="row mb-2">
                <div className="col d-flex align-items-end">
                    <h6>Productos registratos</h6>
                </div>
                <div className="col d-flex justify-content-end">
                    <div className="d-flex flex-row gap-3">
                        <div className="col d-flex flex-row align-items-center gap-2">
                            <label htmlFor="items-by-page" className="form-label mb-0">Mostrar: </label>
                            <select onChange={onItemsPerPageChange} className="form-select form-select-sm" aria-label="Default select example" name="items-by-page" style={{ width: '70px' }} value={itemsPerPage}>
                                {
                                    ITEMS_BY_PAGE_OPTIONS.map((value) => (
                                        <option value={value} key={'item-by-page-option-' + value}>{value}</option>
                                    ))
                                }
                            </select>
                        </div>
                        <button type="submit" className="btn btn-primary" onClick={resetList} disabled={!hasSearched}>Limpiar búsqueda</button>
                    </div>
                </div>
            </div>
            <div className="table-responsive rounded-3" style={{ border: '1px solid black' }}>
                <table className="table">
                    <thead>
                        <tr>
                            <th scope="col" className="text-center">#</th>
                            <th scope="col" className="text-center">SKU Padre</th>
                            <th scope="col" className="text-center">SKU Hijo</th>
                            <th scope="col" className="text-center">Nombre de Producto</th>
                            <th scope="col" className="text-center">Precio base</th>
                            <th scope="col" className="text-center">Descuento</th>
                            <th scope="col" className="text-center">Subtotal</th>
                            <th scope="col" className="text-center">IVA</th>
                            <th scope="col" className="text-center">Total</th>
                            <th scope="col" className="text-center">Tiene Stock</th>
                            <th scope="col" className="text-center">Número de Centros</th>

                            {showActions &&
                                <th scope="col" className="text-center">Acción</th>
                            }
                        </tr>
                    </thead>
                    <tbody>
                        {
                            products.length > 0 ? products.map((el, i) =>
                                <ProductCrudTableRow
                                    key={el._id}
                                    el={el}
                                    i={i}
                                    editData={editData}
                                    deleteData={deleteData}
                                    setModalShow={setModalShow}
                                    setProduct={setProduct}
                                />)
                                :
                                <tr>

                                    <td
                                        colSpan={showActions ? 12 : 11}
                                        className="text-center"
                                    >
                                        Sin datos
                                    </td>

                                </tr>
                        }
                    </tbody>
                </table>
            </div>
            <div>
                <ReactPaginate
                    previousLabel={"Anterior"}
                    nextLabel={"Siguiente"}
                    breakLabel={"..."}
                    pageCount={countPages}
                    //Cuantas paginas quieres mostrar despues d elos 3 ...
                    marginPagesDisplayed={1}
                    //En cada pagina tiene dos lados, uno izquierda y otro derecha, cuantas n paginas quieres en eso dos lados, excepto para la primera y ultima pagina que para estos cubriran n paginas pero para su dirección de ida o retorno de lado respectivamente
                    pageRangeDisplayed={2}
                    onPageChange={handlePageClick}
                    containerClassName={"pagination justify-content-center mt-3"}
                    pageClassName={"page-item"}
                    pageLinkClassName={"page-link"}
                    previousClassName={"page-item"}
                    previousLinkClassName={"page-link"}
                    nextClassName={"page-item"}
                    nextLinkClassName={"page-link"}
                    breakClassName={"page-item"}
                    breakLinkClassName={"page-link"}
                    activeClassName={"active"}
                />
            </div>
        </div>

    );
}
export default ProductCrudTable;
